import { rightsizingRecommendationsSelector } from "../rightsizingRecommendationsSelector";
import { RootState } from "../../../../store";

export const rightsizingRecommendationsLoadingSelector = (
  state: RootState,
): boolean => {
  return !!rightsizingRecommendationsSelector(state)?.isLoading;
};
